import handleError from '../util/handleError';
import getComponentData from '../dom/getComponentData';
function mount(factory, selector) {
  let rootElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  let render = arguments.length > 3 ? arguments[3] : undefined;
  const thisRender = render !== null && render !== void 0 ? render : globalThis.ReactDOM.render;
  const mountPoints = rootElement.querySelectorAll(selector);
  Array.prototype.forEach.call(mountPoints, mountPoint => {
    try {
      const props = getComponentData(mountPoint);
      thisRender(factory(props || {}), mountPoint);
    } catch (error) {
      handleError(error);
    }
  });
}
export default mount;